import moment from 'moment/moment'
import { EInvoiceType, routes } from '@linqpal/models'
import { currencyMask, dateMask } from '../../../../utils/helpers/masking'
import { TFunction } from 'react-i18next'
import { BaseTableStore } from '../../../../store/BaseTableStore'
import { IPayable } from '@linqpal/models/src/dictionaries'
import { getSalesDocumentStatusUIOptions } from '../../../../ui/molecules/StatusLabel/options/getSalesDocumentStatusUIOptions'

export interface IPayablesQuotesFilter {
  search?: string
  dateFrom?: string
  dateTo?: string
  dateFromIndex?: number
  statuses?: string[]
}

export interface IQuoteTableItem {
  _id: string
  quoteNumber: string
  totalAmount: string
  expirationDate: string
  status: string
  supplierId: string
  supplierPhone: string
  supplierName: string
}

export class PayablesQuotesStore extends BaseTableStore<
  IQuoteTableItem,
  IPayablesQuotesFilter
> {
  exportFileName = 'quotes_payables'

  vendorId: string | null = null

  filter: IPayablesQuotesFilter = {
    search: '',
    dateFrom: moment().subtract(30, 'days').format('MM/DD/YYYY'),
    dateTo: moment().format('MM/DD/YYYY'),
    dateFromIndex: 0,
    statuses: [''],
  }

  resetFilter() {
    this.filter = {
      search: '',
      dateFrom: moment().subtract(30, 'days').format('MM/DD/YYYY'),
      dateTo: moment().format('MM/DD/YYYY'),
      dateFromIndex: 0,
      statuses: [''],
    }
    this.resetPage()
    this.resetSort()
  }

  setVendorId(id: string) {
    this.vendorId = id
  }

  t: TFunction<'payables'> | undefined

  constructor() {
    super()
    this.initObservable()
  }

  async callApi(params: any): Promise<any> {
    const res = await routes.invoices.payablesInvoices({
      types: [EInvoiceType.QUOTE],
      supplierId: this.vendorId,
      ...params,
    })
    return res
  }

  formatTableItem(invoice: IPayable) {
    return {
      _id: invoice._id,
      quoteNumber: invoice.invoice_number,
      totalAmount: currencyMask(invoice.total_amount),
      expirationDate: invoice.authorization_deadline
        ? dateMask(invoice.authorization_deadline)
        : '-',
      status: invoice.invoiceStatus,
      supplierId: invoice.company?._id || '-',
      supplierPhone: invoice.company?.phone || '-',
      supplierName: invoice.company?.name || '-',
    }
  }

  formatExportItem(tableItem: IQuoteTableItem): { [key: string]: string } {
    if (!this.t) {
      throw new Error('call setTranslation() first')
    }

    return {
      [this.t('payables.tabQuotes.table.VendorName')]: tableItem.supplierName,
      [this.t('payables.tabQuotes.table.QuoteNumber')]: tableItem.quoteNumber,
      [this.t('payables.tabQuotes.table.Amount')]: tableItem.totalAmount,
      [this.t('payables.tabQuotes.table.ExpDate')]: tableItem.expirationDate,
      [this.t('payables.tabQuotes.table.Status')]:
        getSalesDocumentStatusUIOptions(tableItem.status).label,
    }
  }

  setTranslation(t: TFunction<'payables'>) {
    this.t = t
  }
}
